module.exports = __webpack_public_path__ + "media/images/login-hero-5e564b4d221e58004bc29e446c2d94a2.jpg";